// @ts-nocheck
import { getBackendUrl } from "@Utils";
import { useEffect, useState } from "react";
import {
  fileUploadSources,
  optionsViewType,
} from "../PortalSetings/Configuration/FormsAndFields/FormTemplate/constant.helper";
import { formSectionType, getPermissions } from "./constants";
import { convertDate } from "../../services/luxonHelper";
import IconComponent from "../../cubeComponent/icons";
import { FormControl, FormHelperText } from "@mui/material";
import _ from "lodash";
import { teamsService } from "../../services/dataManager";
import { Query } from "@syncfusion/ej2-data";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { showToastNotification } from "../../actions/toast";
import { TOAST_TYPE_WARNING } from "../../services/constants";
import ValidationWrapperWeb from "../FormValidation/ValidationWrapperWeb";
import AddURLModal from "./addURLModal";
import FileManagerAsPopup from "@Components/FileManager/FileManagerAsPopup";
import { getViewerUrl } from "@Helpers";
import AddGeoLocation from "./addGeoLocationModal";
import GoogleMap from "@Components/Map";
import useQuestionFields from "./useQuestionFields";
import { getDistanceInMeters } from "@Helpers/constants";
import {
  fieldRenderers,
  getNoPermissionWarning,
  getOverDistanceWarning,
  getUserCardAndChip,
} from "./questionFieldsHelper";
import { getFileIcon } from "@CubeComponents/constants/globalFunctions";

const FormQuestionFields = (props) => {
  const {
    eachField,
    fieldIndex = null,
    sectionIndex = null,
    section = {},
    source = formSectionType.FORM,
    tableRowIndex = 0,
    tableRowId = null,
    disabled = false,
    handleCustomFieldData = null,
    showAnswersOnly = false,
    formData = {},
    userDetails = {},
    handleInputChange,
    handleChangeAnswer,
    handleURLModalState,
    handleSaveUrlData,
    showUrlModal,
    setURLData,
    spaceId,
    showGeoLocationModal,
    setShowGeoLocationModal,
    extraParams = {},
  } = props;
  const params = useParams();
  const dispatch = useDispatch();
  const lookUpQuery = new Query().addParams("projectId", params.projectId);
  const userId = userDetails.id;
  const [teamsData, setTeamsData] = useState([]);
  const [showFileManager, setShowFileManager] = useState(false);
  let formValidator = props.formValidator || {};
  if (!formValidator.validate) {
    formValidator = useSelector((state) => state.formValidatorStore);
  }
  const {
    _id,
    fieldType,
    lookUpAnsFieldType,
    minFieldRange,
    maxFieldRange,
    viewType = optionsViewType.LIST,
    selectionScope,
    defaultValue = null,
    uploadSource = fileUploadSources.LOCAL,
  } = eachField;

  const { questionId, name, sectionId, currentAnswer, enabled } = useQuestionFields({
    eachField,
    tableRowId,
    extraParams,
    section,
    tableRowIndex,
    source,
    formData,
    userId,
    disabled,
    showAnswersOnly,
    getPermissions,
  });

  const getTeamsData = async (): Promise<void> => {
    const res = await teamsService.executeQuery(lookUpQuery);
    const modifiedData = Array.isArray(res?.result)
      ? res.result.map((team: { _id: string; name: string }) => ({
          id: team._id,
          name: team.name,
        }))
      : [];
    setTeamsData(modifiedData);
  };

  useEffect(() => {
    if (fieldType == "look-up") {
      if (lookUpAnsFieldType == "Teams") {
        getTeamsData();
      } else if (lookUpAnsFieldType == "Location") {
        console.log("");
      }
    }
  }, []);

  useEffect(() => {
    if (defaultValue) {
      formValidator.validate({ name, value: defaultValue });
    }
  }, [defaultValue]);

  const handleFileOpen = (e: any, data: any) => {
    e.stopPropagation();
    const { awsKey, fileVersion } = data;
    let url: string = "";
    if (awsKey) {
      url = `${getBackendUrl()}/fileSystemServer/getAttachmentFile/${awsKey}`;
    } else if (fileVersion) {
      url = getViewerUrl({
        fileVersionId: fileVersion,
        spaceId,
        projectId: params.projectId,
      });
    }
    if (url) {
      window.open(url, "_blank");
    }
  };

  const getFieldAns = () => {
    if (["single-select", "number", "single-line", "multi-line"].includes(fieldType)) {
      return <div className="w-4/5 flex flex-wrap">{currentAnswer.value}</div>;
    }
    if (fieldType == "multi-select") {
      return currentAnswer.value?.join(",");
    }
    if (fieldType == "date-time") {
      return currentAnswer.value ? convertDate(Number(currentAnswer.value), "dateForTooltip") : "";
    }
    if (fieldType == "look-up") {
      const ansDisplay = currentAnswer.value?.map((ans) => ans.name);
      return ansDisplay?.length ? ansDisplay?.join(",") : "";
    }
    if (fieldType == "users") {
      return (
        <div className="flex flex-wrap gap-5 pt-5">
          {currentAnswer.value?.map((user: Object) => getUserCardAndChip({ user, p: { ...props, enabled } }))}
        </div>
      );
    }
    if (fieldType == "fileUpload") {
      return (
        <span className="flex flex-col pe-3 overflow-auto gap-4 w-full h-full">
          {currentAnswer.value?.map((data: any, index: number) => (
            <span
              key={`${data.name}-${index}`}
              className="flex gap-3 border-solid border-2 border-button_light w-fit pe-2 rounded-sg ps-2 items-center"
            >
              <IconComponent onClick={(e) => handleFileOpen(e, data)} name="openInViewer" />
              <span className="w-14 h-10 flex items-center object-contain">{getFileIcon(data.name)}</span>
              <span>{data.name}</span>
            </span>
          ))}
        </span>
      );
    }
    if (fieldType == "image") {
      let answerValue = currentAnswer.value;
      return (
        <div className="flex flex-wrap flex-row pe-3 overflow-auto gap-4 w-full h-full">
          {answerValue?.map((data: any) => (
            <span key={data.awsKey} className="w-32 h-32 border-button_light p-1 rounded flex border-2">
              <img
                src={`${getBackendUrl()}/fileSystemServer/getAttachmentFile/${data.awsKey}`}
                alt="logo"
                width="100%"
              />
            </span>
          ))}
        </div>
      );
    }
    if (fieldType == "url") {
      return (
        <a
          target="_blank"
          rel="noreferrer"
          href={_.get(currentAnswer, "value.URL", "")}
          className="text-gradient_color cursor-pointer underline underline-offset-2"
        >
          {_.get(currentAnswer, "value.displayText", "")}
        </a>
      );
    }
    if (fieldType == "geoLocation") {
      const distance = getDistanceInMeters({ pos1: currentAnswer.value?.current, pos2: currentAnswer.value?.selected });
      return currentAnswer.value ? (
        <div className="flex h-80 w-120 border flex-col gap-5 border-button_light p-3 rounded-sg">
          <GoogleMap
            allowManualSelection={false}
            allowPanning={false}
            allowEditing={false}
            autoFetchLiveLocation={false}
            showLiveLocation={!!currentAnswer.value?.current}
            zoomLevel={currentAnswer.value?.mapZoomLevel}
            defaultCenter={currentAnswer.value?.current}
            additionalMarker={currentAnswer.value?.selected}
            allowSearch={false}
          />
          {distance > 500 && getOverDistanceWarning()}
          {eachField?.captureLiveLocation && !currentAnswer.value?.current && getNoPermissionWarning()}
        </div>
      ) : (
        ""
      );
    }
    return "";
  };
  const getMultiSelectAnswer = (args) => {
    if (viewType === optionsViewType.LIST) {
      const prevAns = currentAnswer?.value || [];
      return args.target.checked
        ? [...prevAns, args.target.name]
        : prevAns.filter((ans: string) => ans !== args.target.name);
    }
    return args.target.value;
  };

  const getDateTimeAnswer = (args: any) => {
    if (selectionScope === "currentDateTime") {
      return { answerValue: Date.now(), status: true };
    }
    const dateVal = _.get(args, "$d") ? new Date(args.$d).getTime() : null;
    if (
      (minFieldRange && dateVal && dateVal < minFieldRange) ||
      (maxFieldRange && dateVal && dateVal > maxFieldRange)
    ) {
      return { answerValue: null, status: false, error: "Invalid date cannot be saved" };
    }
    return { answerValue: dateVal, status: true };
  };
  const getLookUpAnswer = (args) => {
    if (lookUpAnsFieldType === "Teams") return args;

    if (lookUpAnsFieldType === "Location") {
      const prevAns = currentAnswer?.value || [];
      if (args.action === "select") {
        return [...prevAns, { id: args.itemData.id, name: args.itemData.text }];
      }
      if (args.action === "un-select" && Array.isArray(prevAns)) {
        return prevAns.filter((loc: any) => loc.id !== args.itemData.id);
      }
    }

    return currentAnswer?.value || [];
  };

  const getFileUploadAnswer = (args: any, currentAnswer: any) =>
    Array.isArray(currentAnswer?.value) ? [...currentAnswer.value, ...args.answer] : [...args.answer];

  const getAnswer = (args: any) => {
    let output: any = { answerValue: "", status: true };

    if (["single-line", "multi-line", "single-select"].includes(fieldType)) {
      output.answerValue = args.target.value || null;
    } else if (fieldType == "multi-select") {
      output.answerValue = getMultiSelectAnswer(args);
    } else if (fieldType == "number") {
      output.answerValue = Number(args.target.value.replace(/,/g, ""));
    } else if (fieldType == "date-time") {
      const result = getDateTimeAnswer(args);
      if (!result.status) {
        return result;
      }
      output.answerValue = result.answerValue;
    } else if (fieldType == "look-up") {
      output.answerValue = getLookUpAnswer(args);
    } else if (fieldType == "fileUpload" && uploadSource === fileUploadSources.FILE_MANAGER) {
      output.answerValue = getFileUploadAnswer(args);
    } else if (fieldType == "geoLocation") {
      output.answerValue = args;
    }
    return output;
  };

  const handleOnBlur = (args: any) => {
    const res = getAnswer(args);
    if (res.status) {
      if (formData._id) {
        handleInputChange({
          answerValue: res.answerValue,
          fieldIndex,
          sectionIndex,
          eachField,
          section,
          tableRowIndex,
          source,
        });
      }
    } else {
      dispatch(
        showToastNotification({
          content: res.error,
          type: TOAST_TYPE_WARNING,
        }),
      );
    }
  };

  const handleOnChange = (args: any) => {
    const res = getAnswer(args);

    if (formValidator?.validate) {
      formValidator.validate({ name, value: res.answerValue });
    }
    if (res.status) {
      if (handleChangeAnswer) {
        handleChangeAnswer({
          source,
          answerValue: res.answerValue,
          fieldIndex,
          sectionIndex,
          questionId,
          tableRowIndex,
        });
      }
      if (handleCustomFieldData) {
        handleCustomFieldData({
          args: extraParams,
          eachField,
          answerValue: res.answerValue,
          fieldIndex,
          sectionIndex,
          tableRowIndex,
          source,
        });
      }
    }
  };

  const handleFileUploadClick = () => {
    if (uploadSource == fileUploadSources.LOCAL) {
      document.getElementById(`${name}`).click();
    } else {
      setShowFileManager(true);
    }
  };

  const handleRemoveLocation = () => {
    handleOnChange(null);
    handleOnBlur(null);
  };

  const getFieldAnsComponent = () => {
    const renderer = fieldRenderers[fieldType];
    const fieldComponent = renderer ? (
      renderer({
        ...props,
        formValidator,
        questionId,
        name,
        sectionId,
        currentAnswer,
        enabled,
        handleOnChange,
        handleOnBlur,
        handleRemoveLocation,
        lookUpQuery,
        teamsData,
        handleFileUploadClick,
        handleFileOpen,
      })
    ) : (
      <></>
    );

    const showCustomValidation = ["look-up", "users", "fileUpload", "image", "url", "geoLocation"].includes(fieldType);

    return showCustomValidation ? (
      <ValidationWrapperWeb value={currentAnswer.value} name={name} validator={formValidator}>
        {fieldComponent}
      </ValidationWrapperWeb>
    ) : (
      <FormControl fullWidth error={!!_.get(formValidator, `error.${name}`)}>
        {fieldComponent}
        {!!_.get(formValidator, `error.${name}`) && (
          <FormHelperText sx={{ marginInlineStart: 0 }}>{_.get(formValidator, `error.${name}`)}</FormHelperText>
        )}
      </FormControl>
    );
  };

  const handleFileSelectedCancelClick = () => {
    setShowFileManager(false);
  };

  const handleFileSelectedButtonClick = (args: any) => {
    const selectedFiles = Object.values(args).map((file: any) => ({
      fileVersion: file.fileVersion,
      fileId: file.hierarchyId,
      resourceType: file.resourceType,
      versionNumber: file.versionNumber,
      name: file.name,
    }));

    handleOnChange({ answer: selectedFiles });
    handleOnBlur({ answer: selectedFiles });
    handleFileSelectedCancelClick();
  };

  const handleSaveLocation = ({ current, selected, mapZoomLevel }: any) => {
    if (showGeoLocationModal?.eachField?.allowManualSelection) {
      handleOnChange({ current, selected, mapZoomLevel });
      handleOnBlur({ current, selected, mapZoomLevel });
    } else {
      handleOnChange({ current, selected: current, mapZoomLevel });
      handleOnBlur({ current, selected: current, mapZoomLevel });
    }
    setShowGeoLocationModal({ state: false });
  };
  return (
    <>
      {showAnswersOnly ? getFieldAns() : getFieldAnsComponent()}
      {showFileManager && (
        <FileManagerAsPopup
          projectId={params.projectId}
          handleFileSelectedButtonClick={handleFileSelectedButtonClick}
          handleFileSelectedCancelClick={handleFileSelectedCancelClick}
          workspaceId={spaceId}
          hideIssues
          hideTasks
          hideEstimates
          hideSchedules
          hideContracts
          hideExternalSpace
          enableFilesTypes={["RESOURCE_TYPE_FILE", "RESOURCE_TYPE_FOLDER", "RESOURCE_TYPE_MERGED_FILE"]}
        />
      )}
      {showUrlModal?.state && (
        <AddURLModal
          setURLData={setURLData}
          showUrlModal={showUrlModal}
          handleCustomFieldData={handleCustomFieldData}
          handleURLModalState={handleURLModalState}
          handleSaveUrlData={handleSaveUrlData}
          name={name}
        />
      )}
      {showGeoLocationModal?.state && name == showGeoLocationModal.uniqueId && (
        <AddGeoLocation
          setShowGeoLocationModal={setShowGeoLocationModal}
          showGeoLocationModal={showGeoLocationModal}
          handleSaveLocation={handleSaveLocation}
          name={name}
        />
      )}
    </>
  );
};
export default FormQuestionFields;
